import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiImage } = FiIcons;

const Header = () => {
  return (
    <motion.header 
      className="bg-white shadow-lg border-b-2 border-indigo-200"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-center space-x-3">
          <motion.div
            className="bg-indigo-500 p-3 rounded-full"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={FiImage} className="text-white text-2xl" />
          </motion.div>
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-800">
              Thumbnail Downloader
            </h1>
            <p className="text-gray-600 mt-1">
              Extract and download thumbnails from video URLs
            </p>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;